import { CollideEvent, CollideId, TapCollider } from '../../defs/collide';
import type { CageBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { CollideHandler, ICollision } from './ICollision';

/*
    cage block collision resolver
*/
export class CageCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _entity: CageBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
  };

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, entity: CageBlockEntity) {
    this._entity = entity;
  }

  // impl
  //-------------------------------------------------------------------------
  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap(event: CollideEvent) {
    const cell = (event.collider as TapCollider).cell;
    const layer = cell.base;

    // Trigger tap collision on the block underneath the bubble
    layer?.entity.c.block.collide('tap', { type: 'tap', cell });
    return false;
  }
}
